export enum EDatabaseType {
  Unknown = 0,
  PostgreSql = 1,
  SqlServer = 2,
}

export const databaseTypeStrings = [
  EDatabaseType[EDatabaseType.Unknown],
  EDatabaseType[EDatabaseType.PostgreSql],
  EDatabaseType[EDatabaseType.SqlServer],
];
